import { render, staticRenderFns } from "./CompanyFileListCard.vue?vue&type=template&id=0544d797"
import script from "./CompanyFileListCard.vue?vue&type=script&lang=js"
export * from "./CompanyFileListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports